import { ESRI_CREDENTIALS_KEY } from "./constants";
import { createLocalStorageStateHook } from "use-local-storage-state";

export interface AugmentedEsriToken extends __esri.IdentityManagerRegisterTokenProperties {
  refresh_token: string;
  expires_at: number;
}

/** Create single localStorage entry point */
export const useEsriToken = createLocalStorageStateHook<AugmentedEsriToken | undefined>(ESRI_CREDENTIALS_KEY);
